<div class="overflow-x-hidden ">
    <div class="cart-item px-5 w-full">
        <div *ngFor="let data of cardsData;let i= index;" class="w-full  px-5 py-2 my-5 cart-item 
            flex gap-2  relative  bg-white shadow-md">
            <div *ngIf="data.available_quantity < 1 "
                class="translate-x-2 -translate-y-2 absolute top-0 right-0 rounded-full bg-red-700">
                <p class="text-white antialised text-center p-2 text-xs text-wrap">Out of <br> Stock</p>
            </div>
            <div class="w-1/2 cart-item-image">
                <img [routerLink]="['/products',data.slug]" [src]="data.main_image" alt="product"
                    class="" [ngClass]="minimal?'w-20 h-20':'w-24 h-24 md:w-min md:h-min '"
                    [ngStyle]="{'mix-blend-mode': data.available_quantity?'':'luminosity', }">
            </div>
            <div class="w-1/2 cart-item-details flex flex-grow flex-col space-x-1 justify-evenly antialiased">
                <p class="font-bold text-black  text-xs text-wrap" [routerLink]="['/products',data.slug]">{{data.title}}
                </p>
                <p class="text-sm text-black">{{data.description}}</p>
                <p class="text-xs text-gray-500">{{data.size}}</p>
                <div class="p-2 bg-gray-100 rounded-md flex flex-row justify-between items-center">
                    <p class=" text-lg font-semibold">₹ {{data.quantity * data.discounted_price}} &nbsp; <span
                            class="line-through text-black text-red-500 text-sm">{{data.quantity *
                            data.actualPrice}}</span> </p>
                    <p> </p>
                </div>
                <!-- <div class="flex flex-row flex-wrap cursor-pointer">
                    <div *ngFor="let item of data.product_sizes" class="border-red-100 border-secondary m-1">
                        <input type="radio" [checked]="data.size == item.size" [value]="item.id"
                            name="product_size{{item.id}}" (click)="changeProductSize(item.id, item.quantity)">
                        <label>{{item.size}}</label>
                    </div>
                </div> -->
                <!-- <p *ngIf="data.quantity && data.available_quantity <= 5 && data.available_quantity > 0"
                    class="text-xs mt-2 text-black">Only
                    <span class="text-red-700">{{data.available_quantity}} Left</span> in stock
                </p> -->

                <div class="my-5 relative" *ngIf="data.available_quantity > 1">
                    <div *ngIf="data.loading" class="mx-auto cardLoader"></div>
                    <ng-container *ngIf="!data.loading && !minimal">
                        <button 
                            class="border-2 hover:border-primary bg-white bg-primary-dark shadow-md  hover:scale-105 text-black font-bold py-1 px-2 rounded shadow-md"
                            (click)="decreaseQuantity(i,data.product_size_id,data.product_id,data.quantity-1)">-</button>
                        <span class="mx-2">{{ data.quantity }}</span>
                        <button 
                            class="bg-white border-2 hover:border-primary bg-primary-dark shadow-md  hover:scale-105 text-black font-bold py-1 px-2 rounded shadow-md"
                            (click)="increaseQuantity(i,data.product_id, data.product_size_id,data.quantity, data.available_quantity)">+</button>
                    </ng-container>
                </div>
                <i *ngIf="!data.loading && !minimal"
                    class="pi pi-trash cursor-pointer hover:text-red-800 text-primary text-left py-1 mx-2 align-text-bottom"
                    (click)="removeItem(i, data.product_size_id)">&nbsp;Remove</i>
            </div>
        </div>
    </div>

    <div *ngIf="!showLoader && cardsData.length < 1 " class="empty-container h-screen ">
        <div class="empty-cart flex flex-col items-center justify-center align-middle center h-1/2">
            <i
                class="pi pi-cart-plus text-8xl text-transparent bg-clip-text bg-gradient-to-r from-primary via-orange-500 to-red-800 transition duration-500 ease-in-out transform hover:-translate-y-1 hover:scale-110 animate-pulse"></i>
            <h3 class="text-lg text-black text-center md:text-5xl mt-2 text-3xl antialiased text-slate-600">Your cart is <span
                    class="text-primary">empty</span></h3>
            <!-- <button class="btn btn-primary bg-gradient-to-r mt-2 from-primary via-orange-500 to-red-800 text-white font-bold py-2 px-4 rounded-full transition duration-500 ease-in-out transform hover:-translate-y-1 hover:scale-110 animate-pulse"
                routerLink="/products">Shop
                Now</button> -->
            <button class="btn btn-primary text-white mt-2 bg-primary font-bold py-2 px-4 rounded-full hover:scale-110"
                (click)="navigateToBuy()">Shop
                Now</button>
        </div>
    </div>

    <div *ngIf="showLoader" class="absolute w-full h-full flex justify-center  overflow-hidden items-center">
        <p-progressSpinner strokeWidth="2" animationDuration=".5s" />
    </div>
</div>